@if ($tmplContent(); as tmplContent) {
  <div class="osp-dialog-content">
    <ng-container [ngTemplateOutlet]="tmplContent" />
  </div>
}

@if ($tmplFooter(); as tmplFooter) {
  <div class="osp-dialog-footer">
    <ng-container [ngTemplateOutlet]="tmplFooter" />
  </div>
}
